import { Component, Injector } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { ReviewManager } from '@managers/review.manager';
import { BaseComponent } from 'src/app/components/base.component';
import { LexbeDoc } from '@models/doc.model';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';

@Component({
    template: ``,
    standalone: false
})
export class RelatedTabBaseComponent extends BaseComponent {
	public currentDocumentSnapshot: LexbeDoc;
	protected docViewerStore: DocViewerStore;
	protected reviewManager: ReviewManager;

	constructor(
		injector: Injector
	) {
		super();
		this.docViewerStore = injector.get(DocViewerStore);
		this.reviewManager = injector.get(ReviewManager);

		this.docViewerStore.currentDocument$.pipe(
			takeUntil(this.destroy$)
		).subscribe((snapshot) => this.currentDocumentSnapshot = snapshot);
	}

	public loadDocument(documentId: string): void {
		this.reviewManager.continueWithoutSavingConfirmationDialog().subscribe((confirm) => {
			if (confirm)
				this.reviewManager.loadDocument(documentId);
		});
	}
}
